export interface UseUserTabbing {
    init: () => void
    destroy: () => void
}

const classKey: string = 'user-is-tabbing'

const removeClass = (): void => document.body.classList.remove(classKey)

const handleKeyDown = (e: KeyboardEvent): void => {
    const { key }: { key: string } = e

    if (key === 'Tab') document.body.classList.add(classKey)
    if (key === 'Escape') removeClass()
}

export const useUserTabbing = (): UseUserTabbing => {
    const init = () => {
        document.addEventListener('keydown', handleKeyDown)
        document.addEventListener('mousedown', removeClass)
    }

    const destroy = () => {
        document.removeEventListener('mousedown', removeClass)
        document.removeEventListener('keydown', handleKeyDown)
    }

    return {
        init,
        destroy,
    }
}
